export default "skymp5-front/52a0532dca770c04879e9636422390bd.png";